(() => {
  const root = document.documentElement;
  const overlay = document.querySelector('[data-bbw-entrance]');

  if (!overlay || !root.classList.contains('bbw-entrance-pending')) return;

  let dismissed = false;

  const dismiss = () => {
    if (dismissed) return;
    dismissed = true;
    root.classList.remove('bbw-entrance-pending');
    overlay.remove();
  };

  overlay.addEventListener('animationend', dismiss, { once: true });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) dismiss();
  }, { once: true });

  // The CSS also hides the overlay at animation end; this removes it if an
  // animation event is missed and prevents it from ever blocking the store.
  window.setTimeout(dismiss, 3500);
})();
